import * as React from 'react';
import { Modal, MessageBoxFunctionalLayout, Text, Box, TextButton, } from 'wix-style-react';
import { translate, Trans, } from 'react-i18next';
var DeleteContactSummary = function (props) {
    var numberOfDeleted = props.numberOfDeleted, numberOfFailed = props.numberOfFailed, isOpen = props.isOpen, t = props.t, onClose = props.onClose, onNavigateToMembersList = props.onNavigateToMembersList;
    var isSingleDeleted = numberOfDeleted === 1;
    var isSingleFailed = numberOfFailed === 1;
    return (React.createElement(Modal, { isOpen: isOpen },
        React.createElement(MessageBoxFunctionalLayout, { title: t('deleteModalHeaderMultiple'), onOk: onClose, onClose: onClose, confirmText: t('deleteSummaryModalConfirm'), theme: "red", dataHook: "delete-contact-summary-modal" },
            React.createElement(Box, { direction: "vertical" },
                React.createElement(Box, { direction: "vertical" },
                    React.createElement(Text, { dataHook: "delete-contact-summary-modal-deleted" }, isSingleDeleted
                        ? t('singleContactDeleted')
                        : t('multipleContactsDeleted', {
                            amount: numberOfDeleted,
                        })),
                    React.createElement(Text, { dataHook: "delete-contact-summary-modal-failed" }, isSingleFailed
                        ? t('singleContactNoDeleted')
                        : t('multipleContactsNoDeleted', {
                            amount: numberOfFailed,
                        })),
                    React.createElement(Text, null,
                        React.createElement(Trans, { defaults: t('delete.contact.summary.hint'), components: [
                                React.createElement(TextButton, { dataHook: "delete-contact-summary-modal-hint-action", key: 1, onClick: onNavigateToMembersList }, "."),
                            ] })))))));
};
export var DeleteContactSummaryModal = translate()(DeleteContactSummary);
//# sourceMappingURL=DeleteContactSummaryModal.js.map